<template>
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.6"
      d="M104.161 38.454L33.4834 39.0273L34.0249 105.784L104.703 105.21L104.161 38.454Z"
      fill="var(--jd-color-line-100)"
    />
    <path
      d="M92.7999 91.2066C74.196 93.4015 59.4754 92.3937 39.5721 91.2066L40.8211 38.5999H100.8L92.7999 91.2066Z"
      fill="var(--jd-color-gray-4)"
    />
    <path
      d="M21.8001 56.1319V86.9881C21.8001 90.6398 24.7604 93.6001 28.4121 93.6001H86.6769C90.0587 93.6001 92.8001 90.8586 92.8001 87.4769V55.0385V29.2121C92.8001 25.5604 89.8398 22.6001 86.1881 22.6001H28.4121C24.7604 22.6001 21.8001 25.5604 21.8001 29.2121V56.1319Z"
      fill="var(--jd-color-surface-400)"
      stroke="var(--jd-color-gray-6)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M85.4364 106.131C96.236 106.131 101.771 106.818 107.355 101.087"
      stroke="var(--jd-color-gray-6)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M56.1765 110.348H66.9026"
      stroke="var(--jd-color-gray-6)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M56.1765 103.075H66.9026"
      stroke="var(--jd-color-gray-6)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M87.8 97.6001H68.8C66.5908 97.6001 64.8 99.391 64.8 101.6V111.6C64.8 113.809 66.5908 115.6 68.8 115.6H87.8C90.0091 115.6 91.8 113.809 91.8 111.6V101.6C91.8 99.391 90.0091 97.6001 87.8 97.6001Z"
      fill="var(--jd-color-gray-4)"
    />
    <path
      d="M108.418 17.2975C108.934 18.3293 108.566 19.5823 107.534 20.0983L102.595 22.6043C101.564 23.1202 100.311 22.7517 99.7946 21.7198C99.2787 20.6879 99.6472 19.4349 100.679 18.919L105.617 16.413C106.649 15.897 107.902 16.3393 108.418 17.2975Z"
      stroke="var(--jd-color-gray-4)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M98.0255 8.59985L94.7824 14.4963"
      stroke="var(--jd-color-gray-4)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.4621 48.2516C28.9505 49.7632 28.9505 52.2141 30.4621 53.7257C31.9738 55.2374 34.4246 55.2374 35.9363 53.7257C48.1683 41.4937 68.0004 41.4937 80.2324 53.7257C81.7441 55.2374 84.1949 55.2374 85.7066 53.7257C87.2182 52.2141 87.2182 49.7632 85.7066 48.2516C70.4512 32.9963 45.7175 32.9963 30.4621 48.2516ZM37.9276 61.1913C36.4159 59.6797 36.4159 57.2288 37.9276 55.7172C49.0598 44.585 67.1087 44.585 78.2409 55.7172C79.7526 57.2288 79.7526 59.6797 78.2409 61.1913C76.7293 62.703 74.2784 62.703 72.7668 61.1913C64.6578 53.0824 51.5107 53.0824 43.4017 61.1913C41.8901 62.703 39.4392 62.703 37.9276 61.1913ZM45.393 64.1504C43.8814 65.6621 43.8814 68.1129 45.393 69.6246C46.9046 71.1362 49.3555 71.1362 50.8671 69.6246C54.853 65.6387 61.3153 65.6387 65.3011 69.6246C66.8128 71.1362 69.2636 71.1362 70.7753 69.6246C72.2869 68.1129 72.2869 65.6621 70.7753 64.1504C63.7661 57.1413 52.4021 57.1413 45.393 64.1504ZM52.6101 72.8853C55.6334 69.862 60.5351 69.862 63.5584 72.8853L58.0843 78.3594L52.6101 72.8853Z"
      fill="var(--jd-color-gray-4)"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'

let id = 0
export default defineComponent({
  name: 'NetworkEmpty',
  setup() {
    const ns = useNamespace('empty')
    return {
      ns,
      id: ++id,
    }
  },
})
</script>
